/* XNote Write PDP shop cards: prev/next (only when the row overflows, hidden on phones by CSS) and a polite
   status line. Add to cart itself is the theme's delegated [data-xp-add] handler in xp-base.js. */
(() => {
  const root = document.querySelector('.xp-write-shop');
  if (!root) return;
  const track = root.querySelector('[data-shop-track]');
  const nav = root.querySelector('[data-shop-nav]');
  const prev = root.querySelector('[data-shop-prev]');
  const next = root.querySelector('[data-shop-next]');
  const status = root.querySelector('[data-shop-status]');
  let lastName = '';

  const sync = () => {
    const overflow = track.scrollWidth - track.clientWidth > 2;
    nav.hidden = !overflow;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  };
  const step = (dir) => {
    const card = track.querySelector('.xp-write-shop__card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap) * 2 });
  };
  prev.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  track.addEventListener('scroll', sync, { passive: true });
  addEventListener('resize', sync);
  sync();

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-shop-name]');
    if (b) lastName = b.dataset.shopName;
  });
  document.addEventListener('xp:cart:added', () => {
    if (!lastName) return;
    status.textContent = '';
    setTimeout(() => { status.textContent = `${lastName} added to cart.`; lastName = ''; }, 50);
  });
  document.addEventListener('xp:cart:error', () => { if (lastName) { status.textContent = `Could not add ${lastName}.`; lastName = ''; } });
})();
